/**
 * La primera página que falta por leer, contando desde el principio. `null` si
 * ya están todas. Sirve para el botón «ir a la siguiente sin leer»: quien no
 * puede acusar tiene que saber adónde volver, no adivinarlo.
 */
export function primeraSinLeer(leidas: ReadonlySet<number>, total: number): number | null {
  for (let pagina = 1; pagina <= total; pagina += 1) if (!leidas.has(pagina)) return pagina;
  return null;
}

/**
 * Lo que la persona escribió en el campo de la página, si es una página que
 * existe. Sólo dígitos: «1o» o «-3» no son una página.
 */
export function paginaValida(texto: string, total: number): number | null {
  if (!/^\d+$/.test(texto.trim())) return null;
  const numero = Number(texto.trim());
  return numero >= 1 && numero <= total ? numero : null;
}

/**
 * Qué página está «a la vista» en la vista continua: la que más alto ocupa de
 * la pantalla. Con dos mitades iguales gana la de arriba, que es la que se
 * está terminando de leer.
 */
export function paginaMasVisible(alturas: ReadonlyMap<number, number>): number | null {
  let mejor: number | null = null;
  let alto = 0;
  for (const [pagina, visible] of [...alturas].sort((a, b) => a[0] - b[0])) {
    if (visible > alto) {
      mejor = pagina;
      alto = visible;
    }
  }
  return mejor;
}
